import store from '../store';

class Page {
    
    /**
     * Set document title based on route title
     * @param {Route} route 
     * @param {Object} user 
     */
    static title(route, user) {
        document.title = route.meta.title(route, user) + ' | SIGV Translation Delivery System';
    }

    /**
     * Check if user has access to the route
     * 
     * @param {Route} route 
     * @param {Object} user 
     * @returns {Boolean}
     */
    static hasAccess(route, user) {

        let hasAccess = false;

        if ( route.meta.access ) {

            Object.keys(route.meta.access).forEach( (role) => {
                if ( route.meta.access[role] && user[role] ) {
                    hasAccess = true;
                }
            });
        }
        else {
            hasAccess = true;
        }

        return hasAccess;
    }

    /**
     * Check if user is 2fa authorized
     * 
     * @param {Route} user 
     * @returns 
     */
    static checkAuthenticator(user) {
        return user.otp_authorized === true;
    }

    /**
     * get appropriate route for 2fa authenication
     * 
     * @param {Object} user 
     * @returns {Route}
     */
    static authenticatorRoute(user) {
        if ( user.otp_enabled === false) {
            return {name: 'verification'};
        }
        else if (user.otp_authorized === false ) {
            return {name: 'verification-qr'};
        }

        return {path:'/'};
    }

    /**
     * Check if user has access to routes.
     * If not, the user will be redirected to the appropriate route
     * 
     * @param {Route} to 
     * @param {Route} from 
     * @param {Function} next 
     */
    static controlRouting(to, from, next) {

        if ( to.meta.private ) {

            store.dispatch('user/authorized').then( (user) => {
                
                if ( Page.checkAuthenticator(user) ) {
                    if ( Page.hasAccess(to, user) ) {
                        Page.title(to, user);
                        next();
                    }
                    else {
                        next({name:'not-found'});
                    }
                }
                else {
                    next(Page.authenticatorRoute(user));
                }
    
            }).catch( () => {
                next({name: 'login'});
            });
        } else if (to.meta.authenticator) {
            store.dispatch('user/authorized').then( (user) => {
                Page.title(to, user);
                next();
            }).catch( () => {
                next({name: 'login'});
            });
        } else {
            Page.title(to);
            next();
        }

    }
}

export default Page;
